event-widget {
    display: block;

    .ew-date-time::first-letter {
        text-transform: uppercase
    }
}